export default __webpack_public_path__ + "static/media/talit-tfilin-mission.388eba50.png";